/**
    * Share description
    * (c) lg2fabrique 2017
*/
import Facebook from 'frontools/social/Facebook';
import Twitter from 'frontools/social/Twitter';
import Context from 'frontools/core/Context';

declare var dataLayer;

export default class Share {
    /**
    * constructor
    */
    constructor() {
        const fbBtns = document.querySelectorAll('[data-share="facebook"]');
        const twBtns = document.querySelectorAll('[data-share="twitter"]');
        const url = Context.getInstance().getURL().host;

        for (let i = 0, l = fbBtns.length; i < l; i++) {
            fbBtns[i].addEventListener('click', () => {
                dataLayer.push({
                    eventCategory: 'page des 10 ans',
                    eventAction: 'partage',
                    eventLabel: 'facebook',
                    event: 'genericGAEvent'
                });
                Facebook.sharer(url, true);
            });
        }

        for (let i = 0, l = twBtns.length; i < l; i++) {
            twBtns[i].addEventListener('click', () => {
                dataLayer.push({
                    eventCategory: 'page des 10 ans',
                    eventAction: 'partage',
                    eventLabel: 'twitter',
                    event: 'genericGAEvent'
                });
                //Ouverture d'un popup pour envoyer un Tweet
                Twitter.tweet({
                    url: url,
                    text: document.querySelector('meta[name="twitter:title"]').getAttribute("content"),
                    hashtags:''
                }, true);
            });
        }
    }
}
